import React from "react";

const AdvanceLoan = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >

        <path  className="u_fill" fill={fill}
            d="m12.725 0 11.609 3.648a1.607 1.607 0 0 1 1.117 1.528V8h3.18c.422 0 .827.169 1.125.469.299.3.466.707.466 1.131v3.2H9.544V9.6c0-.424.167-.831.466-1.131.298-.3.703-.469 1.124-.469H22.27V6.352L12.725 3.35 3.181 6.352v11.846c0 .98.223 1.947.653 2.826a6.393 6.393 0 0 0 1.826 2.245l.3.217 6.765 4.642L18.741 24h-7.607c-.421 0-.826-.169-1.124-.469a1.605 1.605 0 0 1-.466-1.131V16h20.678v6.4c0 .424-.167.831-.466 1.131-.298.3-.703.469-1.124.469l-5.122.002a9.55 9.55 0 0 1-2.227 2.128L12.725 32l-8.558-5.869a9.582 9.582 0 0 1-3.061-3.446A9.646 9.646 0 0 1 0 18.198V5.176c0-.34.109-.673.31-.947.2-.275.483-.478.807-.58L12.725 0Z"
        />
    </svg>
);

export default AdvanceLoan;
